/* eslint-disable */
import React, { Component } from 'react';
import moment from 'moment';

import { connect } from 'react-redux';

import DatePicker from 'material-ui-pickers/DatePicker';

import DialogFactory from '../../factory/DialogFactory';

import DeleteDialog from '../components/DeleteDialog';
import UnauthorizedDialog from '../../common/UnauthorizedDialog';
import SaveSessionToLibrary from './SaveSessionToLibrary';
import RCalendarAutoPublishDialog from './CalendarAutoPublishDialog';
import ConfirmUnsubscribeDialog from './ConfirmUnsubscribeDialog';
import DropSimple from '../../designer/components/DropSimple';

import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import * as CalendarState from '../../../state/reducer/calendar/calendar';
import * as AppState from '../../../state/reducer/app/appState';

import Console from '../../../lib/debug';

import SegmentService, {
    EVENTS as SEGMENT_EVENTS,
} from '../../../lib/segment/SegmentService';

class CalendarDialogs extends Component {
    state = {
        date: moment(),
        timelineDay: 0
    };

    componentWillReceiveProps = nextProps => {
        const date = this.getDefaultDate(nextProps.year, nextProps.month, nextProps.selectedDay);
        this.setState({ date });
    };

    acceptInform() {
        CalendarState.inform(false);
    }

    formatDate(date) {
        let mDate = moment(date, 'YYYY-MM-DD');
        return mDate.format('dddd, MM-DD-YYYY');
    }

    getWeekDay(index) {
        let week = Math.ceil((index + 1) / 7);
        let day = index + 1 - (week - 1) * 7;
        return { week, day };
    }

    getDaySelector() {
        let isProgram = ProgramTypes.isProgram(this.props.programType);
        let totalDays = this.props.totalDays;
        let options = Array.apply(null, { length: totalDays }).map((i, key) => {
            let { week, day } = this.getWeekDay(key);
            return { id: key, title: `Week ${week} - Day ${day}` };
        });
        if (isProgram) {
            return (
                <DropSimple
                    value={this.state.timelineDay}
                    options={options}
                    labelKey="title"
                    valueKey="id"
                    onChange={this.handleWeekDayChange.bind(this)}
                />
            );
        } else {
            return (
                <div>
                    <p>Select the date for your session:</p>
                    <DatePicker value={this.state.date} onChange={this.handleDateChange.bind(this)} />
                </div>
            );
        }
    }

    getDefaultDate = (year, month, selectedDay) => {
        if (selectedDay && selectedDay.date) {
            return moment(selectedDay.date);
        }

        let currentDate = moment();
        if (!year || !month) return currentDate;

        let calendarDate = moment()
            .year(year)
            .month(month - 1)
            .date(1);

        return calendarDate.month() === currentDate.month() && calendarDate.year() === currentDate.year()
            ? currentDate
            : calendarDate;
    };

    handleWeekDayChange(data) {
        let newState = {
            ...this.state,
            timelineDay: data.id
        };
        this.setState(newState);
    }

    handleDateChange(date) {
        let newState = {
            ...this.state,
            date: date
        };
        this.setState(newState);
    }

    handleDialogClose() {
        CalendarState.toggleDrawerCalendarDialog(false, this.props.item);
    }

    handleSaveSessionDialogClose() {
        CalendarState.toggleSaveSessionToLibrary(false);
    }

    async handleSave() {
        let item = this.props.item;
        let type = item.typeElement;
        if (type === 'program') {
            const addProgram = {
                fromCalendarId: item.id,
                toCalendarId: this.props.team.group_id,
                startDate: moment(this.state.date).format('YYYY-MM-DD') + ' 00:00:00'
            };
            CalendarState.toggleDrawerCalendarDialog(false, this.props.item);
            CalendarState.toggleSideNav(false);

            AppState.setLoading('Adding program...');
            await CalendarState.addProgram(addProgram);
            AppState.stopLoading();

            SegmentService.track(SEGMENT_EVENTS['AddToCalendarCTA'].key, {
                sources: 'Web app',
                ctaLocation: 'Calendar dialogs',
                ctaText: 'Add program to calendar',
            });
        } else if (type === 'session') {
            let calendarId = this.props.athleteId ? this.props.programId : this.props.team.id;

            let addSession = {
                program_id: calendarId,
                workout_id: item.id,
                session: 0
            };

            if (!ProgramTypes.isProgram(this.props.programType)) {
                let date = this.state.date;
                if (date && !moment.isMoment(date)) {
                    moment(this.state.date);
                }
                addSession['month'] = this.state.date.month() + 1;
                addSession['day'] = this.state.date.date();
                addSession['year'] = this.state.date.year();
                addSession['startDate'] = moment(this.state.date).format('YYYY-MM-DD') + ' 00:00:00';
            } else {
                let { week, day } = this.getWeekDay(this.state.timelineDay);
                addSession['timeline_day'] = this.state.timelineDay + 1;
                addSession['weekIndex'] = week - 1;
                addSession['index'] = day - 1;
            }

            CalendarState.addSession(addSession);
            CalendarState.toggleDrawerCalendarDialog(false, this.props.item);
            CalendarState.toggleSideNav(false);

            SegmentService.track(SEGMENT_EVENTS['AddToCalendarCTA'].key, {
                sources: 'Web app',
                ctaLocation: 'Calendar dialogs',
                ctaText: 'Add session to calendar',
            });
        }
    }

    handleSessionSave(title) {
        let session = this.props.session;
        session.title = title;
        CalendarState.saveSessionToLibrary(session);
    }

    render() {
        Console.render('CalendarDialogs');
        let item = this.props.item;

        if (!item) {
            return <div />;
        }

        /* Add Program Modal */
        let team = this.props.team || {};
        let addProgramBody = (
            <div className="create-dialog add-program-dialog layout-column">
                <p>
                    Select the date you want {team.title} to start on {item.title}
                </p>
                <DatePicker value={this.state.date} onChange={this.handleDateChange.bind(this)} />
            </div>
        );

        let addProgramModal = (
            <DialogFactory
                enabled={this.props.openProgram ? true : false}
                handleClose={this.handleDialogClose.bind(this)}
                handleSave={this.handleSave.bind(this)}
                header="Choose a Start Date"
                text={addProgramBody}
                cancelButtonTitle="Cancel"
                saveButtonTitle="Add to Calendar"
            />
        );

        /* Add Session Modal */
        let addSessionModal = (
            <DialogFactory
                enabled={this.props.openSession ? true : false}
                handleClose={this.handleDialogClose.bind(this)}
                handleSave={this.handleSave.bind(this)}
                header="Select a Date"
                text={this.getDaySelector()}
                cancelButtonTitle="Cancel"
                saveButtonTitle="Add Session"
            />
        );

        let informModal = (
            <DialogFactory
                enabled={this.props.inform.open ? true : false}
                handleClose={this.acceptInform.bind(this)}
                header={this.props.inform.title}
                text={this.props.inform.message}
                cancelButtonTitle="OK"
            />
        );

        return (
            <div>
                {addProgramModal}
                {addSessionModal}
                {informModal}
                <ConfirmUnsubscribeDialog />
                <SaveSessionToLibrary />
                <RCalendarAutoPublishDialog />
                <DeleteDialog />
                <UnauthorizedDialog />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        item: state.calendar.uiTree.drawerDialogs.item,
        openProgram: state.calendar.uiTree.drawerDialogs.program,
        openSession: state.calendar.uiTree.drawerDialogs.session,
        inform: state.calendar.uiTree.drawerDialogs.inform,
        team: state.calendar.infoTree.team,
        athleteId: state.calendar.infoTree.athleteId,
        programId: state.calendar.infoTree.programId,
        programType: state.calendar.infoTree.programType,
        totalDays: state.calendar.uiTree.drawerDialogs.totalDays,
        saveSessionToLibraryDialog: state.calendar.uiTree.saveSessionToLibraryDialog,
        session: state.calendar.uiTree.session,
        month: state.calendar.infoTree.month,
        year: state.calendar.infoTree.year,
        selectedDay: state.calendar.uiTree.selectedDay
    };
};

CalendarDialogs = connect(mapStateToProps)(CalendarDialogs);

export default CalendarDialogs;



// WEBPACK FOOTER //
// ./src/view/calendar/calendar-dialogs/CalendarDialogs.jsx